/**
 * 
 * Good palettes
 *   x Candy x3
 *   x azazel
 *   x Jurassic
 *   x mahjong
 *   x Yellowstone
 *   x cymbidium
 *   x 5meo
 *   x Kendall?
 *   - Prodigy
 *  
 * Bad
 *  x Goa
 *  x Planet
 *  x Lubov
 *  x Jaeger
 *  x ancient
 *  x ghost
 *  x christmas
 *  x lime
 *  x bufo
 *  - mercury
 * 
 * - Rarities! 
 *   - Certain palettes
 *   - Acid, other textures?
 *   - Symmetry?
 *   - Animation speeds?
 * - Features script with better names (group animation timings etc)
 * 
 * Overexposure on a lot of eyes - can we clamp bright white/colors somehow?
 *  - Try a generalized blowout protection? (if color > X clamp it, or smoothstep it?)
 *  - Overexposure happens (e.g.0xe8b90b51813079ff55f053bfff62355b96ffff80471e00000420694206942069)
 *    - 0x5d17f3612567cfff55f0532000006b745d0055ff842600800420694206942069
 *    - 0x5d1746b686279effff9cbbffffd8f6a7e400ff000cc500800420694206942069 (palette bw)
 *   - bw palette overexposes on some patterns
 * 
 * CONSTRAINTS to add
 *  - animation:
 *    - Base AND fibers can be still only with certain combos
 *    - non-animated blots with non animated fibers is bad?
 *  - Acid:
 *    - must be used with very interesting fibers and inner ring (inverse fibers look good)
 *  - BW:
 *    - palette can only be used with certain textures
 *  - Inverse doesn't look good with white fibers sometimes?
 * 
 * Non-radial ceramic needs radial fibers?
 * Fibers must be shown with low speed blot?
 * Cassandra doesnt work for high voltage
 * Wisp fibers on ceramic hard to see

 */
/**
 * RARE
 *  - B&W rare?
 *  - Original fibers, paramA should be hard to get a high number
 *  - Maybe Acid is rare (and only used with certain fibers)
 *  
 * COMMON
 *  - Eye-like: Web fibers with param A maxed and radial
 *  - Eye-like: Radial piggys
 *  - Eye-like: original fibers, intensity > 0.7 paramA < 0.2
 * DOPE
 *  - Web fibers with Aqua underneath looks dope
 *  - Simple backgrounds (original, blot, mech etc) with low freq symmetrical graffiti (common?)
 */

/**
 * Constants
 */
const colorPalettes = [
    { name: 'custom', baseColor1: '#000000', baseColor2: '#000000', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#000000', fiberColor: '#000000' },
    { name: 'candy', baseColor1: '#5820e1', baseColor2: '#aded16', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#e30c96', fiberColor: '#19cfc5' },
    { name: 'azazel', baseColor1: '#004c66', baseColor2: '#a70fdc', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#33e6db', fiberColor: '#3b80af' },
    { name: 'jurassic', baseColor1: '#ed0a65', baseColor2: '#b3e11b', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#18d7c0', fiberColor: '#050301' },
    { name: 'gecko', baseColor1: '#27d710', baseColor2: '#0b6945', baseColor3: '#aa1212', baseColor4: '#0d0d11', innerColor: '#ed0d2d', fiberColor: "#000000" },
    { name: 'aqua', baseColor1: '#186691', baseColor2: '#9bd8ff', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#00d1ff', fiberColor: '#ffffff' },
    { name: 'mahjong', baseColor1: '#2b2be6', baseColor2: '#19e6bc', baseColor3: '#c85e5e', baseColor4: '#220808', innerColor: '#c3d45c', fiberColor: '#ca3c29' },
    { name: 'topaz', baseColor1: '#252769', baseColor2: '#14160d', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#777ba7', fiberColor: '#f08c30' },
    { name: 'yellowstone', baseColor1: '#6e5464', baseColor2: '#c3ff03', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#18d7c0', fiberColor: '#a45a15' },
    { name: 'cymbidium', baseColor1: '#0b1925', baseColor2: '#c02222', baseColor3: '#faeae1', baseColor4: '#ffffff', innerColor: '#c8a0ff', fiberColor: '#a46a00' },
    { name: 'undine', baseColor1: '#1652a0', baseColor2: '#cfdc2c', baseColor3: '#843333', baseColor4: '#47c876', innerColor: '#f9ffec', fiberColor: '#050301' },

    { name: 'amazon', baseColor1: '#225722', baseColor2: '#51d276', baseColor3: '#ffffff', baseColor4: '#23cf62', innerColor: '#19404a', fiberColor: '#d97f2e' },
    { name: '5meo', baseColor1: '#0E0A18', baseColor2: '#DA04F2', baseColor3: '#78CBAF', baseColor4: '#C85475', innerColor: '#72F8FF', fiberColor: '#F6EF41' },
    { name: 'theta', baseColor1: '#263664', baseColor2: '#3c4135', baseColor3: '#4d4d4d', baseColor4: '#ac88a3', innerColor: '#af2626', fiberColor: '#2880ff' },
    { name: 'candy', baseColor1: '#5820e1', baseColor2: '#aded16', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#e30c96', fiberColor: '#19cfc5' },
    { name: 'azazel', baseColor1: '#004c66', baseColor2: '#a70fdc', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#33e6db', fiberColor: '#3b80af' },
    { name: 'kendall', baseColor1: '#e12086', baseColor2: '#aded16', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#bce30b', fiberColor: '#19cfc5' },
    { name: 'jurassic', baseColor1: '#ed0a65', baseColor2: '#b3e11b', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#18d7c0', fiberColor: '#050301' },
    { name: 'izolda', baseColor1: '#f0300d', baseColor2: '#bcfc26', baseColor3: '#de3737', baseColor4: '#161516', innerColor: '#af0046', fiberColor: '#b3e8b3' },
    { name: 'goa', baseColor1: '#911818', baseColor2: '#ffb800', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#ffb400', fiberColor: '#ffffff' },
    { name: 'atlantis', baseColor1: '#00ff0f', baseColor2: '#002dff', baseColor3: '#00e1ff', baseColor4: '#ff0000', innerColor: '#000000', fiberColor: '#ffffff' },

    { name: 'electric', baseColor1: '#6900ff', baseColor2: '#ff00ff', baseColor3: '#00ff41', baseColor4: '#000000', innerColor: '#9500ff', fiberColor: '#ffffff' },
    { name: 'gondwana', baseColor1: '#101020', baseColor2: '#29ff29', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#0096ff', fiberColor: '#ffffff' },
    { name: 'atarax', baseColor1: '#101020', baseColor2: '#ff9c9c', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#ff6a6a', fiberColor: '#ffffff' },
    { name: 'mahjong', baseColor1: '#2b2be6', baseColor2: '#19e6bc', baseColor3: '#c85e5e', baseColor4: '#220808', innerColor: '#c3d45c', fiberColor: '#ca3c29' },
    { name: 'prodigy', baseColor1: '#46463b', baseColor2: '#9d1818', baseColor3: '#3e1f36', baseColor4: '#9d0b0b', innerColor: '#7a5c2b', fiberColor: '#e2f2a9' },
    { name: 'eno', baseColor1: '#000000', baseColor2: '#ffffff', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#ffffff', fiberColor: '#d200ff' },
    { name: 'vurt', baseColor1: '#7f7f0d', baseColor2: '#f092e3', baseColor3: '#025502', baseColor4: '#110000', innerColor: '#3b4359', fiberColor: '#198982' },
    { name: 'tristan', baseColor1: '#78361d', baseColor2: '#010202', baseColor3: '#fafafa', baseColor4: '#443287', innerColor: '#6496ed', fiberColor: '#285050' },
    { name: 'royal', baseColor1: '#26001b', baseColor2: '#810034', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#ff005c', fiberColor: '#fff600' },
    { name: 'pop', baseColor1: '#b1b1b1', baseColor2: '#f000f0', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#d4c700', fiberColor: '#000000' },

    { name: 'yellowstone', baseColor1: '#6e5464', baseColor2: '#c3ff03', baseColor3: '#000000', baseColor4: '#000000', innerColor: '#18d7c0', fiberColor: '#a45a15' },
    { name: 'cymbidium', baseColor1: '#0b1925', baseColor2: '#c02222', baseColor3: '#faeae1', baseColor4: '#ffffff', innerColor: '#c8a0ff', fiberColor: '#a46a00' },
    { name: '5meo', baseColor1: '#0E0A18', baseColor2: '#DA04F2', baseColor3: '#78CBAF', baseColor4: '#C85475', innerColor: '#72F8FF', fiberColor: '#F6EF41' },
    { name: 'unicorn', baseColor1: '#fa26a0', baseColor2: '#05dfd7', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#a3f7bf', fiberColor: '#fff591' },
    { name: 'jupiter', baseColor1: '#ffa41b', baseColor2: '#000839', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#005082', fiberColor: '#00a8cc' },
    { name: 'inferno', baseColor1: '#511845', baseColor2: '#900c3f', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#c70039', fiberColor: '#ff5733' },
    { name: 'earth', baseColor1: '#071a52', baseColor2: '#086972', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#17b978', fiberColor: '#a7ff83' },
    { name: 'dispenza', baseColor1: '#6fe7dd', baseColor2: '#3490de', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#6639a6', fiberColor: '#521262' },
    { name: 'jumanji', baseColor1: '#c3550b', baseColor2: '#9f1dc5', baseColor3: '#000000', baseColor4: '#6cc352', innerColor: '#5f0f0f', fiberColor: '#99b195' },
    { name: 'cassandra', baseColor1: '#a088cf', baseColor2: '#82af32', baseColor3: '#d22b65', baseColor4: '#a5b1ac', innerColor: '#b31335', fiberColor: '#461d0d' },

    { name: 'prodigy', baseColor1: '#46463b', baseColor2: '#9d1818', baseColor3: '#3e1f36', baseColor4: '#9d0b0b', innerColor: '#7a5c2b', fiberColor: '#e2f2a9' },
    { name: 'kendall', baseColor1: '#e12086', baseColor2: '#aded16', baseColor3: '#828282', baseColor4: '#000000', innerColor: '#bce30b', fiberColor: '#19cfc5' },
    { name: 'solar', baseColor1: '#f0e3ca', baseColor2: '#ff8303', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#a35709', fiberColor: '#1b1a17' },
    { name: 'apple', baseColor1: '#ac0c0c', baseColor2: '#a7d82e', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#f5f883', fiberColor: '#fbfadf' },
    { name: 'amaleiya', baseColor1: '#fbecec', baseColor2: '#91d18b', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#e11d74', fiberColor: '#440047' },
    { name: 'oxidized', baseColor1: '#d1f5d3', baseColor2: '#9dc6a7', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#7d5e2a', fiberColor: '#231903' },
    { name: 'suriel', baseColor1: '#341822', baseColor2: '#a7a7a7', baseColor3: '#4a8787', baseColor4: '#ffffff', innerColor: '#cdac81', fiberColor: '#00303f' },
    { name: 'zendo', baseColor1: '#212121', baseColor2: '#6d9886', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#d9cab3', fiberColor: '#f6f6f6' },
    { name: 'alacreme', baseColor1: '#eadeb8', baseColor2: '#cfb784', baseColor3: '#ffffff', baseColor4: '#ffffff', innerColor: '#dc65d1', fiberColor: '#9025ed' },
    { name: 'gordon', baseColor1: '#39391c', baseColor2: '#9d1818', baseColor3: '#d9169f', baseColor4: '#9d0b0b', innerColor: '#ffb94b', fiberColor: '#3dabe8' },
]
const baseTextureTypes = [
    { name: 'Original', value: 1 },
    { name: 'Spotty', value: 2 },
    { name: 'Aqua', value: 3 },
    { name: 'Piggy', value: 4 },
    { name: 'High Voltage', value: 5 },
    { name: 'Blot', value: 6 },
    { name: 'Sparkle', value: 7 },
    { name: 'Gargoyle', value: 8 },
    { name: 'Geometric', value: 9 },
    { name: 'Acid', value: 10 },
    { name: 'Ceramic', value: 11 },
    { name: 'Mech', value: 12 }
]
const fiberTypes = [
    { name: 'none', value: 0 },
    { name: 'Original', value: 1 },
    { name: 'Wisp', value: 2 },
    { name: 'Strong', value: 3 },
    { name: 'Web', value: 4 },
    { name: 'Inverse', value: 5 },
    { name: 'Gargoyle', value: 6 },
    { name: 'High Voltage', value: 7 },
    { name: 'Graffiti', value: 8 }
]
const symmetryTypes = [
    { name: 'none', value: 0 },
    { name: 'horizontal', value: 1 },
    { name: 'vertical', value: 2 },
    { name: 'both', value: 3 },
]
const reflectivityTypes = [
    { name: 'matte', metalness: 0.0, roughness: 0.45 },
    { name: 'plastic', metalness: 0.0, roughness: 0.35 },
    { name: 'glass', metalness: 0.03, roughness: 0.2 }
]
const ringTypes = [
    { name: 'none', value: 0 },
    { name: 'inner', value: 1 },
    { name: 'outer', value: 2 },
]


// Pad given string with leading 0 to reach desired length
const padString = (string, len) => {
    if (string.length >= len) {
        return string
    }
    const add = len - string.length
    for (let i = 0; i < add; i++) {
        string = '0' + string
    }
    return string
}

/**
 * Random parameter generation.
 * Takes a hash and creates a set of 32 params each 0-255
 */
class HashParams {
    // pass in a string of the form '0x11ac128f8b54949c12d04102cfc01960fc496813cbc3495bf77aeed738579738'
    constructor(hash) {
        let p = []
        for (let i = 0; i < 64; i += 2) {
            p.push(hash.slice(i + 2, i + 4))
        }
        this.p = p
    }

    // Return the hash value
    getHash() {
        let hash = "0x"
        for (let i = 0; i < this.p.length; i++) {
            hash += this.p[i]
        }
        return hash
    }

    // Return a number scaled to the specified range, with the specified distribution
    // First argument is the specified parameter from the hash (0-31)
    // Note maximum resolution here is 256 values
    getNum(i, min, max, dist) {
        const val = parseInt(this.p[i], 16) / 255
        return val * (max - min) + min
    }

    // Return a selection from a list
    // First argument is specified parameter
    // Maximum resolution 256
    getEnum(i, list, dist) {
        let pos = Math.floor(parseInt(this.p[i], 16) / 255 * list.length)
        pos = Math.min(pos, list.length - 1) // Bit of a hack - means last position has slightly higher odds
        return list[pos]
    }

    // Use 2 params (i and i+1) for higher precision in range
    getDoubleNum(i, min, max, dist) {
        const val = parseInt(this.p[i] + this.p[i + 1], 16) / 65535
        return val * (max - min) + min
    }

    // Use 2 params (i and i+1) for higher precision (especially with distribution functions)
    getDoubleEnum(i, list, dist) {
        let pos = Math.floor(parseInt(this.p[i] + this.p[i + 1], 16) / 65535 * list.length)
        pos = Math.min(pos, list.length - 1) // Bit of a hack - means last position has slightly higher odds
        return list[pos]
    }

    /**
     * Below functions modify the hash value, be careful (used for creating artist choice hashes)
     */

    setNum(i, val, min, max, dist) {
        if (val < min || val > max) {
            return this.p[i]
        }
        const scaled = ((val - min) / (max - min)) * 255
        const hex = padString(Math.round(scaled).toString(16), 2)
        return this.p[i] = hex
    }

    setEnum(i, val, list, dist) {
        let pos = list.indexOf(val)
        if (pos < 0) {
            return this.p[i]
        }
        const scaled = (pos / (list.length - 1)) * 255
        const hex = padString(Math.round(scaled).toString(16), 2)
        return this.p[i] = hex
    }

    setDoubleNum(i, val, min, max, dist) {
        if (val < min || val > max) {
            return (this.p[i] + this.p[i + 1])
        }
        const scaled = ((val - min) / (max - min)) * 65535
        const hex = padString(Math.round(scaled).toString(16), 4)
        this.p[i] = hex.slice(0, 2)
        this.p[i + 1] = hex.slice(2, 4)
        return (this.p[i] + this.p[i + 1])
    }

    setDoubleEnum(i, val, list, dist) {
        let pos = list.indexOf(val)
        if (pos < 0) {
            return (this.p[i] + this.p[i + 1])
        }
        const scaled = (pos / (list.length - 1)) * 65535
        const hex = padString(Math.round(scaled).toString(16), 4)
        this.p[i] = hex.slice(0, 2)
        this.p[i + 1] = hex.slice(2, 4)
        return (this.p[i] + this.p[i + 1])
    }
}

/**
 * Generate properties based on token (include probabilities)
 * Pass in a HashParams that has been initialized
 */
const generateProperties = (p) => {
    const properties = {}
    properties.hash = p.getHash()

    // Base texture
    properties.baseTextureType = p.getDoubleEnum(0, baseTextureTypes.map(e => e.name), 'uniform') // TODO: weighted
    properties.baseTextureFrequency = p.getNum(2, 0, 1, 'uniform')
    properties.baseParamA = p.getNum(3, 0, 1, 'uniform')
    properties.baseParamB = p.getNum(4, 0, 1, 'uniform')
    properties.baseParamC = p.getNum(5, 0, 1, 'uniform')
    properties.baseAnimation = p.getNum(6, 0, 1, 'uniform') // TODO: discrete values?
    properties.baseRadial = (p.getNum(7, 0, 1, 'uniform') > 0.5) // TODO: dependency on type?
        // Radial requires a symmetry (to prevent seam)
    if (properties.baseRadial) {
        properties.baseSymmetry = p.getEnum(8, symmetryTypes.map(e => e.name).slice(1), 'uniform') // TODO: weighted
    } else {
        properties.baseSymmetry = p.getEnum(8, symmetryTypes.map(e => e.name), 'uniform') // TODO: weighted, and dependency on radial?
    }

    // Colors
    properties.colorPalette = p.getDoubleEnum(9, colorPalettes.map(e => e.name).slice(1), 'uniform') // TODO: weighted, and dependency on base texture
    properties.baseColor1 = colorPalettes[0].baseColor1
    properties.baseColor2 = colorPalettes[0].baseColor2
    properties.baseColor3 = colorPalettes[0].baseColor3
    properties.baseColor4 = colorPalettes[0].baseColor4
    properties.innerColor = colorPalettes[0].innerColor
    properties.fiberColor = colorPalettes[0].fiberColor

    // Fibers
    // Fibers required for mech, ceramic, acid, spotty, original, sparkle
    if (['Mech', 'Ceramic', 'Acid', 'Spotty', 'Original', 'Sparkle'].includes(properties.baseTextureType)) {
        properties.fiberType = p.getDoubleEnum(11, fiberTypes.map(e => e.name).slice(1), 'uniform') // TODO: weighted, dependent on base type
    } else {
        properties.fiberType = p.getDoubleEnum(11, fiberTypes.map(e => e.name), 'uniform') // TODO: weighted, dependent on base type
    }
    properties.fiberFrequency = p.getNum(13, 0, 1, 'uniform')
    properties.fiberIntensity = p.getNum(14, 0, 1, 'uniform')
    properties.fiberParamA = p.getNum(15, 0, 1, 'uniform')
    properties.fiberAnimation = p.getNum(16, 0, 1, 'uniform')
    properties.fiberRadial = (p.getNum(17, 0, 1, 'uniform') > 0.5) // TODO: dependency on type?
        // Radial requires a symmetry (to prevent seam)
    if (properties.fiberRadial) {
        properties.fiberSymmetry = p.getEnum(18, symmetryTypes.map(e => e.name).slice(1), 'uniform')
    } else {
        properties.fiberSymmetry = p.getEnum(18, symmetryTypes.map(e => e.name), 'uniform')
    }

    // Inner ring
    properties.innerRingType = p.getEnum(19, ringTypes.map(e => e.name), 'uniform')
    properties.innerRingSize = p.getNum(20, 0, 1, 'uniform')
    properties.innerRingSpread = p.getNum(21, 0, 1, 'uniform')
    properties.dragonPupil = (p.getNum(22, 0, 1, 'uniform') > 0.99)

    // Reflectivity and Lighting
    properties.reflectivityMaterial = p.getEnum(23, reflectivityTypes.map(e => e.name), 'uniform')

    // Background
    // TODO

    // Layout
    // TODO

    // Animation settings (not randomizing)
    properties.eyeMovementMinPeriod = 3
    properties.eyeMovementMaxPeriod = 5
    properties.eyeMovementProbability = 0.33
    properties.eyeMovementRange = 0.2
    properties.eyeHoldTimeMin = 0.4
    properties.eyeHoldTimeMax = 2
    properties.blinkMinPeriod = 10
    properties.blinkMaxPeriod = 20
    properties.blinkProbability = 0.5
    properties.dilationMinPeriod = 20
    properties.dilationMaxPeriod = 30
    properties.dilationProbability = 0.5
    properties.dilationHoldTimeMin = 3
    properties.dilationHoldTimeMax = 10

    return properties
}



/**
 * Generate a token based on the passed in properties
 * (This needs to be updated to match when gerateProperties() changes)
 */
const propertiesToToken = (properties) => {
    const hash = new HashParams('0x0000000000000000000000000000000000000000000000000420694206942069')

    hash.setDoubleEnum(0, properties.baseTextureType, baseTextureTypes.map(e => e.name), 'uniform')
    hash.setNum(2, properties.baseTextureFrequency, 0, 1, 'uniform')
    hash.setNum(3, properties.baseParamA, 0, 1, 'uniform')
    hash.setNum(4, properties.baseParamB, 0, 1, 'uniform')
    hash.setNum(5, properties.baseParamC, 0, 1, 'uniform')
    hash.setNum(6, properties.baseAnimation, 0, 1, 'uniform')
    hash.setNum(7, (properties.baseRadial ? 1 : 0), 0, 1, 'uniform')
    if (properties.baseRadial) {
        hash.setEnum(8, properties.baseSymmetry, symmetryTypes.map(e => e.name).slice(1), 'uniform')
    } else {
        hash.setEnum(8, properties.baseSymmetry, symmetryTypes.map(e => e.name), 'uniform')
    }
    hash.setDoubleEnum(9, properties.colorPalette, colorPalettes.map(e => e.name).slice(1), 'uniform')
    if (['Mech', 'Ceramic', 'Acid', 'Spotty', 'Original', 'Sparkle'].includes(properties.baseTextureType)) {
        hash.setDoubleEnum(11, properties.fiberType, fiberTypes.map(e => e.name).slice(1), 'uniform')
    } else {
        hash.setDoubleEnum(11, properties.fiberType, fiberTypes.map(e => e.name), 'uniform')
    }
    hash.setNum(13, properties.fiberFrequency, 0, 1, 'uniform')
    hash.setNum(14, properties.fiberIntensity, 0, 1, 'uniform')
    hash.setNum(15, properties.fiberParamA, 0, 1, 'uniform')
    hash.setNum(16, properties.fiberAnimation, 0, 1, 'uniform')
    hash.setNum(17, (properties.fiberRadial ? 1 : 0), 0, 1, 'uniform')
    if (properties.fiberRadial) {
        hash.setEnum(18, properties.fiberSymmetry, symmetryTypes.map(e => e.name).slice(1), 'uniform')
    } else {
        hash.setEnum(18, properties.fiberSymmetry, symmetryTypes.map(e => e.name), 'uniform')
    }
    hash.setEnum(19, properties.innerRingType, ringTypes.map(e => e.name), 'uniform')
    hash.setNum(20, properties.innerRingSize, 0, 1, 'uniform')
    hash.setNum(21, properties.innerRingSpread, 0, 1, 'uniform')
    hash.setNum(22, (properties.dragonPupil ? 1 : 0), 0, 1, 'uniform') > 0.99
    hash.setEnum(23, properties.reflectivityMaterial, reflectivityTypes.map(e => e.name), 'uniform')

    return hash.getHash()
}


/**
 * Calculate features for the given token data.
 * @param {string} hash - Unique hash generated upon minting the token.
 */
const calculateFeatures = (hash) => {
    const properties = generateProperties(new HashParams(hash))

    const features = {
        palette: properties.colorPalette,
        texture: properties.baseTextureType,
        fibers: properties.fiberType,
        ring: properties.innerRingType,
        baseMirror: properties.baseSymmetry,
        fiberMirror: properties.fiberSymmetry,
        baseRadial: properties.baseRadial.toString(),
        fiberRadial: properties.fiberRadial.toString(),
        baseAnimation: properties.baseAnimation,
        fiberAnimation: properties.fiberAnimation,
        reflectivity: properties.reflectivityMaterial
    }
    if (properties.dragonPupil) {
        features["dragon"] = "true"
    }
    return features
}

export { colorPalettes, baseTextureTypes, fiberTypes, symmetryTypes, reflectivityTypes, ringTypes, HashParams, generateProperties, propertiesToToken }